module.exports = __webpack_public_path__ + "vfn-assets/img/img-pasos-descuentos-icono.4d1796e8.svg";